import { Link } from 'react-router';
import { NOT_FOUND_META } from '../content/siteMetadata';

export const handle = { bodyClass: 'site-info' };

export const meta = () => NOT_FOUND_META;

function NotFoundPage() {
  return (
    <main className="info-page">
      <section className="info-hero">
        <p className="info-eyebrow">404</p>
        <h1>That page is not on the beers.</h1>
        <p className="info-lead">
          The route you asked for does not exist. Go back to the live verdict or jump into one of
          the Australian city guides.
        </p>
        <div className="info-actions">
          <Link to="/" className="info-button info-button-primary">
            Back to Day For It
          </Link>
          <Link to="/city/brisbane" className="info-button info-button-secondary">
            Try a city guide
          </Link>
        </div>
      </section>
    </main>
  );
}

export default NotFoundPage;
